<template>
  <div class="about-container">
    <section class="about-hero">
      <h1>About Happy Dongtan</h1>
      <p class="subtitle">동탄 부모님들을 위한 최고의 생활 가이드</p>
    </section>

    <section class="about-content">
      <div class="content-card">
        <h2>우리의 목표</h2>
        <p>
          Happy Dongtan은 동탄 신도시에 거주하거나 방문하는 가족들을 위해 기획되었습니다. 
          아이와 함께 소중한 시간을 보낼 수 있는 장소부터, 신뢰할 수 있는 병원 정보까지 
          한 곳에서 편리하게 확인하실 수 있도록 돕는 것이 우리의 미션입니다.
        </p>
      </div>

      <div class="content-card">
        <h2>제공하는 정보</h2>
        <ul>
          <li><strong>아이와 뭐하지:</strong> 동탄의 공원, 체험 시설, 유/무료 놀이터 정보</li>
          <li><strong>오늘 뭐먹지:</strong> 아이와 함께 가기 좋은 검증된 맛집 리스트</li>
          <li><strong>키즈 가베/카페:</strong> 부모님과 아이 모두가 즐거운 테마 공간</li>
          <li><strong>병원/약국:</strong> 야간 진료 병원 및 공휴일 운영 약국 정보</li>
          <li><strong>blog:</strong> 생활에 도움이 되는 다양한 로컬 뉴스 및 팁</li>
          <li><strong>놀이터:</strong> 아이들이 마음껏 뛰어놀 수 있는 야외 공간 정보</li>
          <li><strong>자유게시판:</strong> 이웃들과 소통하고 정보를 나누는 커뮤니티</li>
        </ul>
      </div>

      <div class="content-card faq-section">
        <h2>자주 묻는 질문 (FAQ)</h2>
        <div class="faq-item">
          <h3>Q: 정보는 얼마나 자주 업데이트되나요?</h3>
          <p>A: 맛집 및 키즈 시설 정보는 매주 정기적인 업데이트를 수행하며, 병원 및 약국 데이터는 상시 최신 상태를 유지하기 위해 노력하고 있습니다.</p>
        </div>
        <div class="faq-item">
          <h3>Q: 추천하고 싶은 장소가 있는데 제보가 가능한가요?</h3>
          <p>A: 네, 언제든지 '자유게시판' 또는 '문의하기' 섹션을 통해 소중한 정보를 공유해 주시면 검토 후 사이트에 반영하고 있습니다.</p>
        </div>
        <div class="faq-item">
          <h3>Q: 동탄 이외의 지역 정보도 제공하나요?</h3>
          <p>A: 현재는 동탄 1, 2신도시에 집중하여 가장 정확하고 깊이 있는 로컬 정보를 제공하는 것을 목표로 하고 있습니다.</p>
        </div>
      </div>

      <!-- Bottom Ad Unit -->
      <AdComponent slotId="9173007135" />
    </section>
  </div>
</template>

<style scoped>
.about-container {
  padding-bottom: 100px;
}
.about-hero {
  background-color: var(--card-bg);
  padding: 100px 22px;
  text-align: center;
}
.about-hero h1 {
  font-size: 3rem;
  margin-bottom: 20px;
}
.subtitle {
  font-size: 1.5rem;
  color: var(--text-secondary);
}
.about-content {
  max-width: 800px;
  margin: 0 auto;
  padding: 60px 22px;
}
.content-card {
  margin-bottom: 40px;
  line-height: 1.8;
  background: var(--card-bg);
  padding: 30px;
  border-radius: 20px;
}
.content-card h2 {
  font-size: 1.8rem;
  margin-bottom: 20px;
  border-bottom: 2px solid var(--accent);
  display: inline-block;
  padding-bottom: 5px;
}
.faq-item {
  margin-bottom: 20px;
}
.faq-item h3 {
  font-size: 1.1rem;
  color: var(--accent);
  margin-bottom: 8px;
}
.content-card ul {
  list-style: none;
  padding: 0;
}
.content-card li {
  margin-bottom: 10px;
}
</style>
